module.exports = __webpack_public_path__ + "02_long_brown.4a1de041.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_long_brown.png
// module id = ItkZ
// module chunks = 0